import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../services';

/*
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
*/

@Component({
    selector: 'page-takeaway-order-info-print',
    templateUrl: 'takeaway-order-info-print.html',
})
export class TakeawayOrderInfoPrintPage {
    footer: any;
    header: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public takeawayServices: TakeawayServices) {
            
    }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-info-print/takeaway-order-info-print.ts